import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate, useParams } from "react-router-dom";
import TablePagination from "./TablePagination";
import StandardDatePicker from "./StandardDatePicker";

const ClientDataEntryDetailsLayer = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  
  const [searchTerm, setSearchTerm] = useState("");
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
  });

  const clientMap = {
    "1": "John Doe",
    "2": "Sarah Smith"
  };
  const selectedClient = clientMap[id] || "John Doe";

  const [reportData, setReportData] = useState([
    { sNo: 1, companyName: "Elite Constructions", keyPerson: "John Doe", mobileNumber: "9000010001", email: "john@elite.com", expoName: "Global Trade Fair 2026", date: "2026-03-15" },
    { sNo: 2, companyName: "Elite Constructions", keyPerson: "John Doe", mobileNumber: "9000010001", email: "john@elite.com", expoName: "Build Expo 2026", date: "2026-04-10" },
    { sNo: 3, companyName: "Modern Interiors", keyPerson: "Sarah Smith", mobileNumber: "9000020002", email: "sarah@modern.com", expoName: "Home Decor Fair 2026", date: "2026-03-20" },
    { sNo: 4, companyName: "Elite Constructions", keyPerson: "John Doe", mobileNumber: "9000010001", email: "john@elite.com", expoName: "Interior Design Expo", date: "2026-05-05" }
  ]); 

  const filteredData = reportData.filter(item => 
    item.keyPerson === selectedClient && (
      !searchTerm || 
      item.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.expoName.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="card h-100 p-0 radius-12 overflow-hidden border-0 shadow-sm">
      <div
        className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between"
        style={{ background: "linear-gradient(135deg, #000000, #bb0007, #ed1c24)" }}
      >
        <h6 className="text-white mb-0 fw-bold uppercase">CLIENT DATA DETAILS - {selectedClient.toUpperCase()}</h6>
        
        <div className="d-flex align-items-center gap-3">
            <div className="position-relative" style={{ width: "280px" }}>
                <input 
                    type="text" 
                    className="form-control form-control-sm radius-8 ps-32" 
                    placeholder="Search Expo / Company..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ 
                        backgroundColor: "#fff", 
                        border: "1px solid rgba(255,255,255,0.2)", 
                        color: "black",
                        fontWeight: "500"
                    }}
                />
                <Icon 
                    icon="solar:magnifer-linear" 
                    className="position-absolute start-0 top-50 translate-middle-y ms-12 text-dark opacity-75" 
                />
            </div>
            <button 
                onClick={() => navigate(-1)} 
                className="btn btn-sm d-flex align-items-center gap-2 text-white border-white border-opacity-50 px-16" 
                style={{ backgroundColor: "rgba(255,255,255,0.1)" }}
            >
                <Icon icon="solar:alt-arrow-left-bold" />
                Back
            </button>
        </div>
      </div>
      <div className="card-body p-16">
        <div
          className="p-16 radius-12 mb-16 border"
          style={{ backgroundColor: "#f7e7da" }}
        >
          <div className="row g-3 align-items-end">
            <div className="col-md-6">
                <div className="d-flex align-items-center gap-3">
                    <div>
                        <label className="mb-1 fw-bold text-secondary" style={{ fontSize: "10px" }}>FROM DATE</label>
                        <StandardDatePicker
                            name="fromDate"
                            value={formData.fromDate}
                            onChange={handleInputChange}
                            compact={true}
                        />
                    </div>
                    <div>
                        <label className="mb-1 fw-bold text-secondary" style={{ fontSize: "10px" }}>TO DATE</label>
                        <StandardDatePicker
                            name="toDate"
                            value={formData.toDate}
                            onChange={handleInputChange}
                            compact={true}
                        />
                    </div>
                </div>
            </div>
            <div className="col-md-6 d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-sm btn-dark px-24 py-8 radius-8 fw-bold"
              >
                Search
              </button>
              <button
                type="button"
                className="btn btn-sm btn-danger px-24 py-8 radius-8 d-flex align-items-center gap-2 fw-bold"
                style={{ backgroundColor: "#ed1c24", border: "none" }}
              >
                <Icon icon="solar:printer-bold" className="text-lg" />
                PRINT
              </button>
            </div>
          </div>
        </div>

        <div className="table-responsive border radius-8 bg-white overflow-hidden shadow-sm mb-16">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                <th scope="col" className="fw-bold text-white text-xs py-12">S.No</th>
                <th scope="col" className="fw-bold text-white text-xs py-12">Expo Name</th>
                <th scope="col" className="fw-bold text-white text-xs py-12">Company Name</th>
                <th scope="col" className="fw-bold text-white text-xs py-12">Key Person</th>
                <th scope="col" className="fw-bold text-white text-xs py-12 text-center">Mobile Number</th>
                <th scope="col" className="fw-bold text-white text-xs py-12">E-mail</th>
                <th scope="col" className="fw-bold text-white text-xs py-12 text-center">Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <tr key={index}>
                    <td className="py-10 text-center"><div className="text-xs text-dark">{index + 1}</div></td>
                    <td className="py-10"><div className="text-xs fw-bold text-dark">{item.expoName}</div></td>
                    <td className="py-10"><div className="text-xs text-dark">{item.companyName}</div></td>
                    <td className="py-10"><div className="text-xs text-dark">{item.keyPerson}</div></td>
                    <td className="py-10 text-center"><div className="text-xs text-dark">{item.mobileNumber}</div></td>
                    <td className="py-10"><div className="text-xs text-dark">{item.email}</div></td>
                    <td className="py-10 text-center"><div className="text-xs text-secondary">{item.date}</div></td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-24 text-secondary-light">
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <TablePagination
          currentPage={currentPage}
          totalPages={Math.ceil(filteredData.length / rowsPerPage)}
          onPageChange={(page) => setCurrentPage(page)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            setCurrentPage(0);
          }}
          totalRecords={filteredData.length}
        />
      </div>
    </div>
  );
};

export default ClientDataEntryDetailsLayer;
